import type { ReactElement } from 'react';
import type { AxiosResponse } from 'axios';
import { useRouter } from 'next/router';
import { useIsomorphicLayoutEffect } from '@evrone-erp/react-std';
import { axiosInstance } from '@shared/lib/axios';
import { useNotifications } from '@shared/notifications/model';
import { getErrorMessage, getErrorTitle } from '@shared/lib/helpers';
import type { TAxiosError } from '@shared/lib';
import { ROUTES } from '@shared/lib';
import { ENotificationType } from '@shared/notifications/lib';
type TAuthProviderProps = {
  children: ReactElement;
};
export function AxiosErrorInterceptorProvider({
  children
}: TAuthProviderProps) {
  const {
    showNotification
  } = useNotifications();
  const router = useRouter();
  useIsomorphicLayoutEffect(() => {
    const resInterceptor = (response: AxiosResponse) => response;
    const errInterceptor = (error: TAxiosError) => {
      const status = error.response?.status || 0;
      if (status === 401 && router.route !== ROUTES.login) {
        router.push(`${ROUTES.auth}?callback_url=${ROUTES.account}`);
      }
      if (status === 401 || status === 422 || status === 409) {
        return Promise.reject(error);
      }
      showNotification({
        message: getErrorMessage(error),
        type: ENotificationType.error,
        title: getErrorTitle(error)
      });
      return Promise.reject(error);
    };
    const interceptor = axiosInstance.interceptors.response.use(resInterceptor, errInterceptor);
    return () => axiosInstance.interceptors.response.eject(interceptor);
  }, [router]);
  return children;
}